import { Trash2, RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { Badge } from '@/components/ui/Badge'
import { RocketKanban } from '@/components/RocketSearch/RocketKanban'
import { formatCurrency } from '@/utils/format-currency'
import { formatDate } from '@/utils/format-date'
import type { Deal, DealStage } from '@/types'

type Props = {
  deals: Deal[]
  loading: boolean
  viewMode: 'kanban' | 'list'
  onMoveStage: (dealId: string, stage: DealStage) => void | Promise<void>
  onDelete: (dealId: string) => void
  onDealClick: (deal: Deal) => void
}

export function RocketSearchPipelinePanel({
  deals,
  loading,
  viewMode,
  onMoveStage,
  onDelete,
  onDealClick,
}: Props) {
  if (viewMode === 'kanban') {
    return (
      <RocketKanban
        deals={deals}
        loading={loading}
        onMoveStage={onMoveStage}
        onDelete={onDelete}
        onDealClick={onDealClick}
      />
    )
  }

  return (
    <div className="glass-card p-0 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-[var(--glass-border)]">
              {['Empresa', 'Estágio', 'Valor', 'Prob.', 'Closer', 'Próxima Ação', 'Ações'].map((h) => (
                <th key={h} className="text-left p-3 text-xs font-medium text-[var(--font-color-muted)] uppercase">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {deals.map((deal) => (
              <tr key={deal.id} className="border-b border-[var(--glass-border)] hover:bg-white/5">
                <td className="p-3">
                  <div className="font-medium text-sm">{deal.empresaNome}</div>
                  <div className="text-xs text-[var(--font-color-muted)]">{deal.nome}</div>
                </td>
                <td className="p-3">
                  <Badge
                    variant={
                      deal.etapa === 'ganho' ? 'success' : deal.etapa === 'perdido' ? 'danger' : 'default'
                    }
                  >
                    {deal.etapa}
                  </Badge>
                </td>
                <td className="p-3 text-sm">{deal.valor ? formatCurrency(Number(deal.valor)) : '-'}</td>
                <td className="p-3 text-sm">{deal.probabilidade}%</td>
                <td className="p-3 text-sm">{deal.closerNome || '-'}</td>
                <td className="p-3 text-xs text-[var(--font-color-muted)]">
                  {deal.dataReuniao ? formatDate(deal.dataReuniao) : '-'}
                </td>
                <td className="p-3">
                  <div className="flex gap-2">
                    <Button variant="ghost" size="sm" onClick={() => onMoveStage(deal.id, 'qualificado')}>
                      <RefreshCw size={14} />
                    </Button>
                    <Button variant="ghost" size="sm" onClick={() => onDelete(deal.id)}>
                      <Trash2 size={14} />
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {deals.length === 0 && !loading && (
          <div className="text-center py-12 text-sm text-[var(--font-color-muted)] italic">
            Nenhum deal encontrado.
          </div>
        )}
      </div>
    </div>
  )
}
